import React from "react";
import ToolMenuIconButton from "../../../common/ToolMenuIconButton";
import { BsFolderPlus } from "react-icons/bs";

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

class AddProjectButton extends React.Component<IProps> {
  render(): JSX.Element {
    return (
      <ToolMenuIconButton
        icon={<BsFolderPlus />}
        tooltip="New Project"
        onClick={this.props.onClick}
      />
    );
  }
}

export default AddProjectButton;
